import AuthService from "../../../Services/authService";

export default class UploadTemplateParameters
{
	constructor(id) 
	{
		this.initialize(id);
	}

	initialize(id)
	{
		let loggedInUser=AuthService.getInstance().GetLoggedInUser();
		
		this.ReportTemplateId=id.toString();
		this.selectedFile=null;
		this.UserId=(loggedInUser===undefined)?0:loggedInUser.userId
	}
}